import { Injectable } from '@angular/core';
import { ConnectionService, ConnectionType } from './connection-service';

@Injectable({
  providedIn: 'root'
})
export class AdaptiveImageService {
  constructor(private connectionService: ConnectionService) { }

  /**
   * Détermine la source d'image optimale selon la vitesse de connexion
   * @param standardSrc URL de l'image standard
   * @returns URL appropriée pour la connexion actuelle
   */
  getOptimalImageSrc(standardSrc: string): string {
    if (!standardSrc) {
      return '';
    }

    // Sur connexion lente, on renvoie une version de l'image de plus faible qualité
    if (this.connectionService.isSlowConnection()) {
      return this.getLowQualityImageUrl(standardSrc);
    }

    return standardSrc;
  }

  /**
   * Transforme l'URL d'une image standard en URL pour une image de basse qualité
   * @param standardSrc URL de l'image standard
   * @returns URL pour la version basse qualité
   */
  private getLowQualityImageUrl(standardSrc: string): string {
    // Vérifie si l'image est déjà dans le format low-quality
    if (standardSrc.includes('-low-quality')) {
      return standardSrc;
    }

    // Décompose l'URL pour insérer le suffixe de basse qualité
    const dotIndex = standardSrc.lastIndexOf('.');
    if (dotIndex === -1) {
      return standardSrc; // Pas d'extension trouvée, renvoie l'URL d'origine
    }

    const baseUrl = standardSrc.substring(0, dotIndex);
    const extension = standardSrc.substring(dotIndex);

    // Si une version basse qualité existe, la renvoyer
    return `${baseUrl}-low-quality${extension}`;
  }
}
